import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Header from "../stories/components/Header.js";
import Image from "../stories/components/Image.js";
import PPTExample from "../assets/templates/PPTExample.png";
import PPTExample2 from "../assets/templates/PPTExample2.png";
import PPTExample1 from "../assets/templates/PPTExample1.png";
import ExampleEmailSignature from "../assets/templates/TemplateExampleEmailSignature.png";
import TemplateBottomtext from '../assets/templates/TemplateBottomtext.png';
import TemplateEnvelope from '../assets/templates/TemplateEnvelope.png';
import TemplateAnnouncement from '../assets/templates/TemplateAnnouncement.png';
import TemplateBusinessCard from '../assets/templates/TemplateBusinessCard.png';


export default function TemplatesPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Maler og presentasjoner"
          lead="Informasjon om bruk av maler og presentasjoner."
        />
        <main>
          <Row className="content">
            <Col md={{ span: 8, offset: 2 }}>
              <h2>Postale</h2>
              <p>Statsforvalterens brevark-mal gjelder både digitalt og trykk. Malverket finnes i profilfonten Open Sans. Malen har format A4.</p>
              
              <h3>Universell utforming</h3>
              <p>Brevmalene er universelt utformet og inneholder predefinerte stiler for overskrift 1, 2 og 3, basert på fonten Open sans. I brev med flere overskriftsnivå, er det viktig at overskriftsstilene benyttes, slik at brevene gjøres tilgjengelige for lesing digitalt med leselist.</p>

              <h3>Viktig i bunntekstene</h3>
              <p>E-postadressene til postmottakene skal stå i denne formen:<br />sfxxpost@statsforvalteren.no<br />Web-adressene skal stå i denne formen: <br />www.statsforvalteren.no/xx</p>
            </Col>
          </Row>
          <Image
            size="medium"
            imgUrl={TemplateBottomtext}
            alt="Et brev med korrekt utformet bunntekst"
          />   
          
          <Row className="content">
            <Col md={{ span: 8, offset: 2 }}>
              <h2>Konvolutter</h2>
              <p>På konvolutter plasseres logoen oppe i venstre hjørne. Returadressen settes på forsiden, som vist på eksemplene slik at den kommer rett ovenfor et eventuelt vindu.</p>
              
              <h3>Statsforvalterens standardformater:</h3>
              <p>C5 med og uten vindu: 162 x 229 mm <br />C4 med og uten vindu: 229 x 324 med mer</p>
            </Col>
          </Row>
          <Image
            size="medium"
            imgUrl={TemplateEnvelope}
            alt="Konvolutter i ulike størrelser og format."
          />   
          
          <Row className="content">
            <Col md={{ span: 8, offset: 2 }}>
              <h2>E-post-signatur</h2>
              <p>Det innføres felles e-postsignatur for alle embetene fra 1.1.2019. Denne vil genereres/lages automatisk, og fletter inn informasjon som tittel, tlf. etc. fra «Active Directory» AD.</p>
            </Col>
          </Row>
          <Image
            size="medium"
            imgUrl={ExampleEmailSignature}
            alt="Eksempel på riktig utformet e-postsignatur."
          />   
          <Row className="content">
            <Col md={{ span: 8, offset: 2 }}>
              <h2>Visittkort</h2>
              <p>Forsiden trykkes med relevant informasjon. Utgangspunktet er «dess mindre, dess bedre». Eksemplene her er for å vise når det er mye tekst, og trangt om plassen. All informasjon, samt logo i sort. Se side 5 for plassering av logo på formatet.</p>
              <p>Vi oppfordrer alle til å ta baksiden i bruk. Vær kreativ. Lek med form og farger, og vis mangfold.</p>
            </Col>
          </Row>
          <Image
            size="medium"
            imgUrl={TemplateBusinessCard}
            alt="Eksempel på visittkort med mønster på baksiden."
          />   
          <Row className="content">
            <Col md={{ span: 8, offset: 2 }}>
              <h2>Kunngjørings- og stillingsannonse</h2>
              <p>
                Verden blir stadig mer digital. Men av og til kan det være behov for en kunngjørings- eller stillingsannonse. Formatet tilpasses gjerne tekstmengde og type medium. De fleste oppegående redaksjonelle medier har en annonseavdeling som er vant med å utarbeide materiell, basert på en profilhåndbok. Viktig at de har tilgang på originalfilene for logo og illustrasjoner.
              </p>
              <p>
                Her er noen hovedregler for å utarbeide annonsemateriell: Statsforvalterens logo står alltid på toppen på en rolig bakgrunn. Det kan være et farget felt, eller hvitt. Font er alltid Open Sans. Titler skal stå i en større og fetere variant enn brødtekst.
              </p>
              <p>
                Mønster kan legges som «vannmerke» i bakgrunnen, eller stikke inn fra en kant – dvs. et mønster som er beskåret. Benytt Fylkesmannens fargepallett, se side XX.
              </p>
              <p>
                Annonsen skal ha ramme dersom den ikke fyller hele siden. I bunnen er det en tykkere strek som avslutter formatet.
              </p>
            </Col>
          </Row>
          <Image
            size="medium"
            imgUrl={TemplateAnnouncement}
            alt="Eksempelkunngjøringer med streker på topp og bunn, og mønsterbakgrunn."
          />   
          <Row className="content">
            <Col md={{ span: 8, offset: 2 }}>
              <h2>Powerpoint</h2>
              <p>En gjennomgående PowerPoint- mal skaper identitet og visuell sammenheng i ulike presentasjoner som lages av ansatte hos Statsforvalteren.</p>
              <p>Malen er satt opp i standard størrelse (16:9).</p>
              <p>Malen legges inn lokalt av STAF.</p>
              <p>PowerPoint-malen har fokus på brukervennlighet og variasjons- muligheter. Med dette har Statsforvalterne fått en allsidig og dekkende mal.</p>
              <p>I malen finnes valgfrie forsider og undersider, samt sider for avslutning. Vi anbefaler at man følger malen, og ikke drar i bildebokser eller bruker bildebokser i andre former (som rund osv.).</p>
              <p>Alle sidene har beskrivende navn. Sidene har tips til bedre presentasjoner. Følg dem. Det er et poeng at titlene på alle tekstsider begynner på samme sted på siden og er i samme punktstørrelse. Det gir øyet et fast holdepunkt når du bytter side.</p>
            </Col>
          </Row>
          <Image
            size="medium"
            imgUrl={PPTExample1}
            alt="Bilde av powerpoint-slides"
          />
          <Image
            size="medium"
            imgUrl={PPTExample}
            alt="Bilde av powerpoint-slides"
          />
          <Row className="content">
            <Col md={{ span: 8, offset: 2 }}>
            <h2>Generell anbefaling:</h2>
            <p>Bruk minst mulig tekst. Husk: Det er DU som presenterer. Sidene skal understøtte dine poeng. Unngå høytlesing av lange tekster. Bruk stikkord, og fyll inn muntlig. Del heller opp presentasjonen i mange sider med få punkter på hver side, enn å fylle opp sidene med “bullet-points”.</p>
            </Col>
          </Row>
          <Image
            size="medium"
            imgUrl={PPTExample2}
            alt="Et stort utvalg powerpoint-slides"
          />          
        </main>
      </article>
    </Container>
  );
}
